import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { ReactElement, useCallback, useEffect, createRef } from 'react'
import styled from 'styled-components'
import AgeInput from 'components/AgeInput'
import Chapter from 'components/Chapter'
import FooterCredits from 'components/FooterCredits'
import { sectionsDE } from './sections-de'
import { useLocalStorage } from 'usehooks-ts'
import { GlobalVariables } from 'Globals/GlobalVariables'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const [birthYear, setBirthYear] = useLocalStorage('birthYear', -1)
  const appRef = createRef<HTMLDivElement>()

  useEffect(() => {
    window.addEventListener('userBirthyear', onHandleBirthyear)
    return () => {
      window.removeEventListener('userBirthyear', onHandleBirthyear)
    }
  }, [])

  // the function that is called when the event 'userBirthyear' is fired
  const onHandleBirthyear: any = useCallback((event: CustomEvent) => {
    setBirthYear(event.detail)
  }, [])

  const sections = sectionsDE(birthYear, appRef)
  const modules: { [key: string]: ReactElement } = {
    ageinput: <AgeInput />,
    footercredits: <FooterCredits />,
    chapters: (
      <div className='chapters-wrapper'>
        <Chapter data={sections.telephone} bg='light' />
        <Chapter data={sections.internet} bg='dark' />
        <Chapter data={sections.music} bg='light' />
        <Chapter data={sections.tv} bg='dark' />
        <Chapter data={sections.socialmedia} bg='light' />
      </div>
    ),
  }

  return (
    <AppContainer $colorMode={colorMode} ref={appRef}>
      {modules[properties.module]}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  background-color: #222;
  @media (min-width: 1931px) {
    margin: 0 -50%;
  }
`

export default MainComponent
